/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Course } from './Course';
import { FinalizedLTI1p1Provider } from './FinalizedLTI1p1Provider';
import { FinalizedLTI1p3Provider } from './FinalizedLTI1p3Provider';
import { NonFinalizedLTI1p1Provider } from './NonFinalizedLTI1p1Provider';
import { NonFinalizedLTI1p3Provider } from './NonFinalizedLTI1p3Provider';
const ExtendedCourseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'ltiProvider',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([
            NonFinalizedLTI1p3Provider,
            NonFinalizedLTI1p1Provider,
            FinalizedLTI1p3Provider,
            FinalizedLTI1p1Provider,
        ])),
        'lti_provider',
    ],
]), Course);
export class ExtendedCourse extends Course {
    static decode(input) {
        return ExtendedCourseParser.decode(input).map(res => new ExtendedCourse(res));
    }
    static unsafeDecode(input) {
        return ExtendedCourse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedCourseParser.encode(data);
    }
    static schema() {
        return ExtendedCourseParser.schema();
    }
}
